import React from 'react'
import { useParams } from 'react-router'

import { useVersioning } from 'modules/versioning'
import { RouteParams } from '@sketch/constants'
import * as Styles from './CloseButton.styles'

export function CloseButton() {
  const { shareID } = useParams<RouteParams<'PROTOTYPE'>>()
  const { getPathname } = useVersioning()

  const to = getPathname({
    routeKey: 'SHARE_VIEW',
    routeParams: {
      shareID,
    },
  })

  return (
    <Styles.Link to={to} aria-label="Close prototype">
      <Styles.Icon />
    </Styles.Link>
  )
}
